import { render, staticRenderFns } from "./scene9.vue?vue&type=template&id=61a71794&scoped=true&"
import script from "./scene9.vue?vue&type=script&lang=ts&"
export * from "./scene9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a71794",
  null
  
)

export default component.exports